import configDev from './env/configDev';
import configPrd from './env/configPrd';
import configStg from './env/configStg';

export interface AppConfig {
  env: string;
  url: {
    userWeb: string;
    customerWeb: string;
  };
  apiGateway: {
    region: string;
    endpoint: string;
  };
  s3: {
    region: string;
    bucket: {
      staticContents: {
        name: string;
        endpoint: string;
      };
      upload: {
        name: string;
      };
    };
  };
  ses: {
    from: {
      address: string;
    };
  };
  cognito: {
    region: string;
    userPoolId: string;
    clientId: string;
    identityPoolId: string;
  };
}

let config!: AppConfig;

switch (import.meta.env.VITE_STAGE) {
  case 'prd':
    config = configPrd;
    break;
  case 'stg':
    config = configStg;
    break;
  case 'dev':
    config = configDev;
    break;
  default:
    config = configDev;
}

export default config;
